<template>
  <button
      :class="buttonClass"
      :style="buttonStyle"
      :disabled="disableBtn"
      :type="buttonType"
      @mouseenter="updateHoverState(true)"
      @mouseleave="updateHoverState(false)"
  >
    <slot/>
  </button>
</template>

<script>
import {validateProp} from 'utils/utils';

export const ButtonColor = {
  BRAND: 'brand',
  DEFAULT: 'default',
};

export const TYPE = {
  FILL: 'fill',
  STROKE: 'stroke',
  GHOST: 'ghost',
};

export const BUTTON_TYPE = {
  BUTTON: 'button',
  SUBMIT: 'submit'
};

export default {
  data(){
    return {
      hoverState:false
    }
  },
  props: {
    link: Boolean,
    color: {
      type: String,
      default: ButtonColor.DEFAULT,
      validator: value => validateProp(ButtonColor, value)
    },
    customStyle: {
      type: Object,
      default: void 0
    },
    type: {
      type: String,
      default: TYPE.FILL,
      validator: value => validateProp(TYPE, value)
    },
    buttonType: {
      type: String,
      default: BUTTON_TYPE.BUTTON,
      validator: value => validateProp(BUTTON_TYPE, value)
    },
    isHover: {
      type: Boolean,
      default: false
    },
    disableBtn: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateHoverState(isHover) {
      this.hoverState = isHover;
    }
  },
  computed: {
    buttonClass() {
      return [
        'button-' + this.color,
        'button-type-' + this.type,
        'button-btn'
      ];
    },
    buttonStyle() {
      var modifier = '';
      if (this.hoverState && this.isHover)
        modifier = 'Hover';

      if(this.customStyle){
        return{
          backgroundColor: this.customStyle['backgroundColor' + modifier],
          'color': this.customStyle.color,
          'border-radius': this.customStyle.borderRadius,
          'padding': this.customStyle.padding,
        }
      }
      return {};
    },
  }
}
</script>

<style scoped lang="scss">
button {
  border: 0;
  cursor: pointer;
  width: auto;
}

.button-link {
  cursor: pointer;
  display: inline-block;
}

.button-type-stroke{
  background: transparent;
  border: 2px solid;
}

</style>